import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Section for Utilities and Context
import './peopleFeed.css';
import './leadershipList.css';
import { AuthContext } from "../utils/AuthContext";
import API from "../utils/API";
import { LEADERSHIP_TITLES_BY_ORG } from "../utils/leadershipTitles";

// Section for Components
import AddLeadershipPositionModal from "./AddLeadershipPositionModal";
import EditLeadershipPositionModal from "./EditLeadershipPositionModal";
import defaultPortrait from "../assets/portrait-5.png";


// MAIN FUNCTION
export default function LeadershipList(props) {
    const { isAdmin } = useContext(AuthContext);
    const navigate = useNavigate();
    const [positions, setPositions] = useState([]);
    const [editData, setEditData] = useState({});
    const [showHistorical, setShowHistorical] = useState(false);

    const reRenderLeadership = () => {
        API.getLeadershipPositions(props.organization_id)
            .then(res => setPositions(res.data))
            .catch(err => console.log(err));
    };

    useEffect(() => {
        if (props.organization_id) reRenderLeadership();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.organization_id]);

    function formatMonthYear(dateString) {
        const date = new Date(dateString);
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${year}`;
    }

    const titleOrder = LEADERSHIP_TITLES_BY_ORG[props.organization_id] || [];
    const orderIndex = (title) => {
        const idx = titleOrder.indexOf(title);
        return idx === -1 ? titleOrder.length : idx;
    };

    const current = positions
        .filter(p => !p.end_date)
        .sort((a, b) => orderIndex(a.title) - orderIndex(b.title));

    const historical = positions
        .filter(p => p.end_date)
        .sort((a, b) => new Date(b.end_date) - new Date(a.end_date));

    function leaderCard(position) {
        const profile = position.ProfileInfo;
        const dateRange = position.end_date
            ? `${formatMonthYear(position.start_date)} – ${formatMonthYear(position.end_date)}`
            : `Since ${formatMonthYear(position.start_date)}`;

        return (
            <div
                key={position.id}
                className="people-card leadership-card"
                onClick={() => profile && navigate("/profile/" + profile.profile_id)}
            >
                <img
                    src={profile?.profile_picture || defaultPortrait}
                    className="people-card-picture"
                    alt={profile ? `${profile.first_name} ${profile.last_name}` : "Unknown"}
                />

                <div className="people-card-details">
                    <span className="people-card-name">{profile ? `${profile.first_name} ${profile.last_name}` : "Unknown"}</span>
                    <span className="people-card-title">{position.title}</span>
                    <span className="people-card-division">{dateRange}</span>
                </div>

                {isAdmin && (
                    <i
                        className="bi bi-pencil-square leadership-card-edit"
                        alt="Edit Leadership Position Button"
                        data-bs-toggle="modal"
                        data-bs-target="#editLeadershipModal"
                        onClick={(e) => { e.stopPropagation(); setEditData(position); }}
                    />
                )}
            </div>
        );
    }

    return (
        <>
            <div className="leadership-tab">
                <div className="leadership-header-row">
                    <h6 className="leadership-section-title">Current Leadership</h6>
                    {isAdmin && (
                        <button
                            type="button"
                            className="leadership-add-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#addLeadershipModal"
                        >
                            <i className="bi bi-plus-circle me-1" />Add Leadership Position
                        </button>
                    )}
                </div>

                <div className="people-card-grid">
                    {current.length > 0
                        ? current.map(leaderCard)
                        : <div className="py-2">No current leadership on record.</div>}
                </div>

                {historical.length > 0 && (
                    <div className="leadership-historical">
                        <button
                            type="button"
                            className="leadership-historical-toggle"
                            onClick={() => setShowHistorical(!showHistorical)}
                        >
                            <i className={`bi bi-chevron-${showHistorical ? 'down' : 'right'} me-1`} />
                            {showHistorical ? 'Hide' : 'Show'} past leaders ({historical.length})
                        </button>
                        {showHistorical && (
                            <div className="people-card-grid mt-2">
                                {historical.map(leaderCard)}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {isAdmin && (
                <>
                    <AddLeadershipPositionModal
                        organization_id={props.organization_id}
                        reRenderLeadership={reRenderLeadership}
                    />
                    <EditLeadershipPositionModal
                        data={editData}
                        reRenderLeadership={reRenderLeadership}
                    />
                </>
            )}
        </>
    )
}
